import React, { FC } from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import './Button.scss';
import { twMerge } from 'tailwind-merge';
import { icons } from '../icons';
import { Link } from 'react-router-dom';

export type ButtonIconType = keyof typeof icons;

export type ButtonProps = Omit<AntButtonProps, 'type'> & {
  rounded?: boolean;
  darkMode?: boolean;
  to?: string;
  type?: AntButtonProps['type'] | 'secondary';
  skipBasicStyles?: boolean;
  iconClassName?: string;
  iconType?: ButtonIconType;
};

const sizeList = {
  small: 'ant-btn-sm',
  large: 'ant-btn-lg',
  middle: 'ant-btn-md',
};

const btnTypes = {
  primary: 'ant-btn-primary',
  secondary: 'ant-btn-secondary',
  default: 'ant-btn-default',
  dashed: 'ant-btn-dashed',
  link: 'ant-btn-link',
  text: 'ant-btn-text',
};

export const Button: FC<ButtonProps> = ({
  skipBasicStyles,
  iconType,
  darkMode,
  iconClassName,
  type,
  to,
  ...props
}) => {
  let icon = null;

  if (iconType) {
    const IconComp = icons[iconType];
    icon = <IconComp className={twMerge('mr-1 h-2 w-2 text-lg', iconClassName)} />;
  }

  const basicStyles = twMerge(
    !skipBasicStyles && 'D7-Button',
    'h-auto',
    !props.rounded && '!rounded-[16px]',
    darkMode && 'dark',
    iconType && !props.children && 'icon-only',
    type,
    props.className
  );

  if (to) {
    return (
      <Link
        className={twMerge(
          'ant-btn',
          props.size && sizeList[props.size],
          type && btnTypes[type],
          basicStyles
        )}
        to={to}
      >
        {props.children}
      </Link>
    );
  }
  return (
    <AntButton
      {...props}
      type={type !== 'secondary' ? type : 'default'}
      className={basicStyles}
    >
      {icon}
      {props.children}
    </AntButton>
  );
};
